import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const DoctorsSection = () => {
  const { t } = useLanguage();

  const doctors = [
    {
      name: t('doctor1_name'),
      role: t('doctor1_role'),
      desc: t('doctor1_desc'),
      image: "/Chief Dietitian.png",
    },
    {
      name: t('doctor2_name'),
      role: t('doctor2_role'),
      desc: t('doctor2_desc'),
      image: "/dr sanjay.png",
    },
    {
      name: t('doctor3_name'),
      role: t('doctor3_role'),
      desc: t('doctor3_desc'),
      image: "/dr sandesh sharma.webp",
    },
    {
      name: t('doctor4_name'),
      role: t('doctor4_role'),
      desc: t('doctor4_desc'),
      image: "/vishu jain.jpeg",
    },
    {
      name: 'Dr. Saleem Naik',
      role: 'Visiting consultant Bariatric surgery',
      desc: t('doctor4_desc'),
      image: "/doct-4.png",
    },
  ];

  return (
    <section
      id="doctors"
      className="section-padding bg-soft-sky py-12"
      data-testid="doctors-section"
    >
      {/* Reduced max-width from 6xl to 5xl to shrink the overall section */}
      <div className="max-w-5xl mx-auto px-6">
        
        {/* Section Header */}
        <div className="text-center max-w-2xl mx-auto mb-10 p-2">
          <span className="text-[#800000] font-semibold text-xs uppercase tracking-widest">
            {t('doctors_subtitle')}
          </span>
          <h2
            className="text-2xl sm:text-3xl lg:text-4xl font-bold text-slate-900 mt-1"
            data-testid="doctors-title"
          >
            {t('doctors_title')}
          </h2>
        </div>

        {/* Doctors Grid - 3 items per row, centered */}
        <div className="flex flex-wrap justify-center gap-6">
          {doctors.map((doctor, index) => (
            <div
              key={index}
              className="group bg-white rounded-xl shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden border border-slate-100 w-full sm:w-[calc(50%-1.5rem)] lg:w-[calc(33.333%-1.5rem)] max-w-[320px]"
              data-testid={`doctor-card-${index + 1}`}
            >
              {/* Square image to reduce vertical height */}
              <div className="relative aspect-square overflow-hidden bg-slate-100">
                <img
                  src={doctor.image}
                  alt={doctor.name}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>

              {/* Reduced padding in the content area */}
              <div className="p-4 text-center">
                <h3 className="text-base font-bold text-slate-900 mb-0.5 group-hover:text-[#800000] transition-colors text-xl">
                  {doctor.name}
                </h3>
                <p className="text-[#800000] font-medium text-[11px] mb-2 uppercase tracking-wide">
                  {doctor.role}
                </p>
                <p className="text-slate-500 text-xs leading-relaxed line-clamp-2">
                  {doctor.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DoctorsSection;